export default {
  customize: {
    home: 'Home',
    user: 'User Center',
    userManage: 'User Manage',
    createUser: 'Create User',
    editUser: 'Edit User',
    shop: 'Shop Center',
    shopManage: 'Shop Manage',
    createShop: 'Create Shop',
    editShop: 'Edit Shop',
    // 订单中心
    orderCenter: 'Orders',
    allOrders: 'All',
    unpaidOrders: 'Unpaid',
    paidOrders: 'Paid',
    alreadyPaid: 'Already Paid',
    partUnpaidOrders: 'Partialy Paid',
    pickingOrders: 'Picking',
    orderEdit: 'Order Edit',
    shippedOrders: 'Shipped',
    completed: 'Completed',
    unpaidShippedOrders: 'Unpaid Shipped',
    requestRefundOrders: 'Request Refund',
    completedOrders: 'Completed',
    refundingOrders: 'Refunding',
    refundFinishedOrders: 'Refund Finished',
    closedOrders: 'Closed',
    orderView: 'Check Order',
    pleaseSelect: 'Please Select',
    UploadingImg: 'Uploading Image',
    jpgpngonly: 'JPG/PNG Only',
    multipleOrderNoAllowed:
      'Multiple Order Number Allowed, use "," to separate',
    pleaseEnter: 'Please Enter',
    cancelRefund: 'Cancel Refund',
    Yes: 'Yes',
    emailNotificationSettings: 'Email Notification Settings',
    selectEmailNotificationRecipients: 'Please tick recipients to receive email notifications',
    refundToCreditMsg:
      'Full refund to credit, or partial refund to credit and remaining refund through MyPay(please use MyPay admin panel)',
    refundOperation: 'Refund Operation',
    useMypayAdminForRefundOperation:
      'Please use MyPay system for refund operation',
    poliPayRefundOperation: 'This order used POLi payment，please transfer the money to customer: ',
    submitOrderDetail: 'Submit Order Detail',
    saveWithoutDispatch: 'Save Without Dispatch',
    orderAddressEdit: 'Order address edit',
    IncorrectShippingId: 'Incorrect Shipping ID',
    OrderDetailSaved: 'Order Detail Saved',
    OrderDetailSaveFailed: 'Order Detail Save Failed',
    OrderImgSaved: 'Order Image Saved',
    OrderImgSaveFailed: 'Order Image Save Failed',
    OrderImgDeleted: 'Order Image Deleted',
    OrderImgDeleteFailed: 'Order Image Delete Failed',
    OrderAddressSaved: 'Order Address Saved',
    OrderAddressSaveFailed: 'Order Address Save Failed',
    otherOperation: 'Other Operation',
    updateSuccessfully: 'Successfully Updated!',
    updateFailed: 'Update Failed!',
    settingSuccessfully: 'Successfully Set!',
    settingFailed: 'Setting Failed!',
    createdSuccessfully: 'Successfully Created!',
    createFailed: 'Create Failed!',
    deletedSuccessfully: 'Successfully Deleted!',
    deleteFailed: 'Delete Failed!',
    noPermission: 'No Permission!',
    between8To15Char: 'Length should be between 8 to 15 characters',
    between6To32Char: 'Length should be between 6 to 32 characters',
    between6To128Char: 'Length should be between 6 to 128 characters',
    printInvoice: 'Print Invoice',
    noteComments: 'Comments',
    includeComments: 'Comments',
    initializeFailed: 'initilize failed',
    filterOrderStatus: 'Filter unpaid and closed orders',

    // 交易中心
    paymentChannel: 'Payment Channel',
    paymentSuccess: 'Payment Success',
    transactionCenter: 'Transaction Center',
    transactionList: 'Transaction List',
    refundSuccess: 'Refund Success',
    pleaseSelectTransactions: 'Please select transactions',

    // 商品中心
    merchandiseCenter: 'Merchandise',
    brand: 'Brand',
    categories: 'Categories',
    incompleteIncomplete: 'Info Incomplete',
    categoryName: 'Category Name',
    categoryLogo: 'Category Logo',
    categoryDescription: 'Category Description',
    rankingWeight: 'Ranking weight',
    menu: 'Menu',
    h5HomeCategory: 'H5 Category',
    // 商品品牌
    createBrand: 'Create Brand',
    editBrand: 'Edit Brand',
    viewBrand: 'View Brand',
    brandCreated: 'Brand Successfully Created',
    brandCreatFailed: 'Create Brand Failed',
    brandUpdated: 'Brand Updated Successfully',
    brandUpdateFailed: 'Create Brand Failed',
    brandUnpromoted: 'Brand Unpromoted',
    // 商品分类
    createCategories: 'Create Categories',
    editCategories: 'Edit Categories',
    categoryCreated: 'Category Created Successfully',
    categoryCreateFailed: 'Category Create Failed',
    // 商品管理
    management: 'Management',
    createMerchandise: 'Create Merchandise',
    editMerchandise: 'Edit Merchandise',
    productDisabled: 'Product successfully disabled',
    pleaseSpecifyBatchSpecialPrice: 'Please specify price',
    pleaseChooseEndDate: 'Please choose end date',
    expired: 'Expired',
    // 仓储中心
    stockCenter: 'Stock',
    stockIn: 'Stock In',
    stockOut: 'Stock Out',
    allStock: 'All Stock',

    // 物流中心
    expressCenter: 'Express',
    expressTemplateManagement: 'Templates',
    createTemplate: 'Create Template',
    editTemplate: 'Edit Template',
    expressCompanyList: 'Courier Company',
    CourierCompanyExist: 'Courier Company Exist',
    courierMsg1:
      'Note this affects parcel qty, parcel has minimum weight requirement',
    courierMsg2: 'Note If multiple rules exist, only the last rule will apply',
    shippingFeeCalcutation: 'Shipping Fee Calculation',
    parcelSplitRule: 'Parcel Split Rules',
    shippingFeeMsg1: 'Confirm Parcel Qty',
    shippingFeeMsg2:
      'Max 2 Skincare Product in each parcel, Max 4 cosmetics in each parcel, Max 6 general item in each parcel',
    shippingFeeMsg3:
      'You can mix multiple items in one parcel(including cosmetic & skincare product); You do not have to split parcel if there is no cosmetic or skincare product',
    shippingFeeMsg4: 'Confirm Goods Weight',
    shippingFeeMsg5:
      'Parcel that less than 1KG of Weight will be deemed as 1KG',
    shippingFeeMsg6: '3. Fees',
    shippingFeeMsg7: 'Fees = Weight * Unit Price',
    shippingFeeMsg8:
      '4. There are sub-template options available, please select sub-template if possible',
    shippingTemplateMsg1: 'Shipping Template',
    shippingTemplateMsg2:
      '【Category】【Single/Mix/Unrestricted】【Max Qty Each Parcel】',
    shippingTemplateMsg3: '【Select sub-template according to the district】',
    shippingTemplateMsg4:
      'Note: sub-template does not apply to special district',
    shippingTemplateMsg5: '【xxCountry/xxDistrict】',
    shippingTemplateMsg6: 'xxTemplate',
    parcelRestriction: 'Parcel Restriction',
    cosmetics: 'Cosmetics',
    skinCareProduct: 'Skin Care Product',
    single: 'Single',
    mix: 'Mix',
    unrestricted: 'Unrestricted',
    minParcelWeight: '【Minimum Parcel Weight】',

    // 内容中心
    cmsCenter: 'CMS',
    pcCmsModules: 'Home Manage',
    pcCmsPages: 'Page Management',
    pcNavigate: 'Edit Navigate',
    pcAdBanner: 'Edit Home Banner',
    editAdBanner: 'Edit Banner',
    createAdBanner: 'Create Banner',
    pageSuffixTip: 'Spaces are not allowed, "-" can be used instead',

    // 首页热销推荐
    pcHotSales: 'Edit Hot Sales',
    editHotSales: 'Edit Hot Sales',
    createHotSales: 'Crate Hot Sales',
    hotSalesImage: 'Hot Sales Image',
    deleteHotSales: 'Delete hot sales？',
    mobileHotSalesStatus: 'Mobile Status',
    pcHotSalesStatus: 'PC Status',
    brandList: 'Brand List',

    createPage: 'Create Page',
    editPage: 'Edit Page',
    searchPage: 'Search Page',
    reminder: 'Reminder',

    // 发货仓库
    warehouse: 'Warehouse',
    createWarehouse: 'Create Warehouse',
    editWarehouse: 'Edit Warehouse',

    // 店铺管理
    shopCenter: 'Shop',
    pcShop: 'Shop Management',
    goodsManagement: 'Batch Manage Goods',
    paymentMethodManagement: 'Payment Management',
    notificationManagement: 'Notification Management',
    themeManagement: 'Theme Management',
    themeCustomization: 'Theme Customization',
    theme: 'Theme',
    currentApplied: 'Currently Applied',
    themeOnlyApplyToHome: 'Note: themes applies to H5 home page only',
    publish: 'Publish',
    preview: 'Preview',
    functionCurrentlyDisabled: 'Sorry, theme customization is currently unavailable',
    clickToEnlargeImg: 'Click to enlarge image',
    pcCurrentlyNoTheme: 'PC Version currently no customization needed',
    mobileTheme: 'H5 Theme',
    pcTheme: 'PC Theme',
    confirmToApplyTheme: 'Confirm use selected theme',
    newArrivals: 'New Arrivals',
    recomendedProducts: 'Recommended Products',
    limitedTimeDiscount: 'Limited Time Discount',
    aboutUs: 'About Us',
    clickToEditRelatedBanner: '<-- Click button to edit related banners',
    createBanner: 'Create Banner',
    editBanner: 'Edit Banner',
    importData: 'Import Data',
    goodsImportExportTip: 'Goods Import Export Tips',
    goodsImportMsg1: 'Goods import operation is irreversible',
    goodsImportMsg2: 'Import file must be in xlsx format',
    goodsImportMsg3:
      '3.Goods import & export only support single sku products.',
    goodsImportMsg4:
      '4.System matchs each product through SPU. System update product if SPU matched, otherwise system will create new product for unmatched spu.',
    goodsImportMsg5:
      '5.Please make sure imported product has category, brand, warehouse, discount plan data before perform import operation',
    goodsImportMsg6:
      '6.Use exist name for matching product category, brand, warehouse, discount plan and shipping template. if none matched. system will automatically use the first value.',
    goodsImportMsg7: '7.Product images will not be imported/exported.',
    goodsImportMsg8:
      '8.System creats default image for each imported product, you will need to manually edit before products go live.',
    goodsImportMsg9:
      '9. Import & Export are time-consuming operation, please be patient.',
    importFailed: 'Import Failed',
    importSuccessfully: 'Import Successfully',
    exportFailed: 'Export Failed',
    shopRequiredInfo: 'Required Shop Information',
    shopAdminAccount: 'Shop Administrator Account',
    shopPaymentSetting: 'Shop Payment Setting',
    shopWechatSetting: 'Shop Wechat Setting',
    shopCustomizationSetting: 'Customization Setting',
    shopOtherInfoSetting: 'Other Setting',
    Inactive: 'Inactive',
    Notified: 'Notified',
    Processing: 'Processing',
    Active: 'Active',
    noPosdata: 'There is no POS data',
    importPosTips: 'Importing goods and categories is time-consuming operation, please be patient.',

    // 交易中心
    payType: 'Pay Type',
    payStatus: 'Payment Status',

    // 分销中心
    distributionCenter: 'Distribution',
    distributionList: 'Distribution List',
    withdrawableBalance: 'Withdrawable Balance',
    walletTransaction: 'Wallet Transactions',

    // 会员中心
    memberCenter: 'Member',
    memberList: 'Member List',
    memberView: 'Member Details',
    discountPlans: 'Discount Plans',
    levelList: 'Level List',
    dataError: 'Data Error',
    noComments: 'No Comme',
    editComments: 'Edit Comments',
    edit: 'Edit',
    selectLevel: 'Select Level',

    // 店员中心
    assistantCenter: 'Assistant',
    assistantList: 'Assistant List',
    roleList: 'Role List',
    addAssistant: 'Add Assistant',

    // 统计中心
    statisticsCenter: 'Statistic',
    salesStatistics: 'Sales Statistics',
    ordersStatistics: 'Order Statistics',
    goodsStatistics: 'Goods Statistics',
    membersStatistics: 'Member Statistics',
    last7Days: 'Last 7 Days',
    last14Days: 'Last 14 Days',
    last30Days: 'Last 30 Days',
    sevenDays: '7 Days',

    // 运营中心
    promotiodiscountInputErrornCenter: 'Promotion',
    freeExpressFeePromotion: 'Free Shipping',
    fullReductionPromotion: 'Full Reduction',
    noFullReductionPromotion: 'No optional full deductions',
    promotionUrl: 'Promotion URL',

    // 代理商
    agent: 'Agent',
    agentList: 'Agent List',
    WithdrawList: 'Withdraw Applications',
    agentPromotion: 'Agent Promotion',
    createAgent: 'Create Agent',

    // 优惠券
    couponCenter: 'Coupon Center',
    couponList: 'Coupon List',
    createCoupon: 'Create Coupon',
    editCoupon: 'Edit Coupon',
    couponStatistics: 'Coupon Statistics',
    discountInputError: 'Discount Input Error',
    enterCouponValidTime: 'Please Enter Coupon Valid Time',
    enterUserMaxReceive: 'Please Enter The Max One User Can Receive',
    couponNotLessThan4Char:
      'Coupon should not be less than 4 characters length',

    // 店铺公告
    noticeCenter: 'Notice Center',
    noticeList: 'Notice List',

    // 首页
    numberOfProducts: 'Number Of Products',
    numberOfMembers: 'Number Of Members',
    mobileURL: 'Default Mobile URL',
    mobileNewURL: 'New Mobile URL',
    salesStatistic: 'Sales Statistic',
    pcURL: 'Default PC URL',
    notCompletePaymentInfo: 'You have not completed payment information, if you do not have IE PAY account, please click the link below, ',
    haveIepayAccount: 'If you already have IE PAY account, please click ',
    here: 'Here',
    toCompletePaymentInfo: ' to complete payment information.',
    customizedUrl: 'Customized Url',

    add: 'Add',
    delete: 'Delete',
    refresh: 'Refresh',
    operate: 'Operate',

    // 订单中心
    batchPrintInvoice: 'Batch Print Invoice',
    batchExportOrders: 'Batch Export Orders',
    batchExportPickingInfo: 'Batch Export Picking Info',
    exportExcel: 'Export Excel',
    exportCurrentData: 'Export Current Data',
    exportAllData: 'Export All Data',
    includeSKU: 'Include SKU',
    statusChangeToPickingOnceExported:
      'Order status will be change to picking once exported',
    confirm: 'Confirm',
    orderGoods: 'Order Goods',
    orderMessage: 'Order Message',
    recipientPhone: 'Recipient Phone',
    identityNumber: 'Identity Number',
    identityCard: 'Identity Card',
    orderTimeRange: 'Order time',
    start: 'Start',
    end: 'End',
    orderId: 'Order Id',
    enterTheOrderId: 'Enter the Order Id',
    search: 'Search',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    lastThreeMonths: 'Last Three Months',
    amountofGoods: 'Goods Fee',
    shippingFee: 'Shipping Fee',
    totalFee: 'Total Fee',
    orderStatus: 'Status',
    orderCreateAt: 'Order Time',
    view: 'View',
    express: 'Express Information',
    more: 'More',
    collapse: 'Collapse',
    orderSort: 'Sort',
    consigneePhone: 'Recipient Phone',
    senderName: 'Sender Name',
    senderPhone: 'Sender Phone',
    senderAddress: 'Sender Address',
    offlinePayment: 'Offline Transfer',
    pickup: 'Pick up',
    unbound: 'N/A',
    pleaseSelectOrders: 'Please Select Orders',
    createdDesc: 'Create Time Desc',
    createdAsc: 'Create Time Asc',
    updatedDesc: 'Update Time Desc',
    updatedAsc: 'Update Time Asc',
    ordersPerPage: 'Orders Per Page',
    no: 'No',
    notApplicable: 'N/A',
    none: 'N/A',
    orderFeeDetai: 'Order fee details',
    originalGoodsFee: 'Original Goods Price',
    originalShippingFee: 'Original shipping fee',
    discountedGoodsFee: 'Discounted goods price',
    discountedShippingFee: 'Discounted shipping fee',
    orderShopPrice: 'Order price',
    orderFinalPrice: 'Final total price',
    barcode: 'Barcode',
    profit: 'Profit',
    costFee: 'Cost',
    sellPrice: 'Selling price',
    sellShippingFee: 'Shipping fee',
    sellTotalFee: 'Total fee',
    receiver: 'Receiver',
    receiverPhone: 'Receiver Phone',
    writeOffButton: 'Write Off',
    havePickedUp: 'Write Off',
    updateStatus: 'Update Status',
    writeOffDetail: 'Goods have been picked up',
    writeOffSuccessfully: 'Write off successfully',
    writeOffFailed: 'Write off failed',
    displayInOrderLogs: 'Display In Order Operation Logs',
    displayInOrders: 'Display In Order Detail',
    displayOrderComments:
      'Cutomer order comments, display on Invoice or order excel file',

    // 订单详情
    orderDetail: 'Order Detail',
    customerId: 'Customer Id',
    paymentMethod: 'Payment Method',
    shippingAddress: 'Shipping Address',
    shippingPerson: 'Shipping Name',
    customerMessage: "Customer's Message",
    paymentTime: 'Payment Time',
    deliveryTime: 'Delivery Time',
    completeTime: 'Complete Time',
    productList: 'Product List',
    productThumbnail: 'Product Thumbnail',
    productTitle: 'Product Title',
    productId: 'Product Id',
    unitPrice: 'Unit Price',
    amount: 'Amount',
    discountInformation: 'Discount',
    total: 'Total',
    orderOperation: 'Order Operation',
    modifyTheOrderPrice: 'Modify the Order Price',
    expressNumber: 'Express Number',
    goodsName: 'Goods Name',
    expressDetails: 'Express Details',
    operationNotes: 'Operation Remark',
    closed: 'Closed',
    unpaid: 'Unpaid',
    paid: 'Paid(unshipped)',
    partialyPaid: 'Partialy Paid',
    picking: 'Picking',
    shipped: 'Shipped',
    unpaidShipped: 'Unpaid Shipped',
    transactionComplete: 'Transaction Complete',
    requestARefund: 'Request a Refund',
    refundCompleted: 'Refund Completed',
    submit: 'Submit',
    paymentDetail: 'Payment Detail',
    viewPaymentDetail: 'View payment detail',
    orderOperationLog: 'Order Operation Log',
    operator: 'Operator',
    operatingTime: 'Operating Time',
    operationalAttributes: 'Operational Attributes',
    operationDetails: 'Operation Details',
    modifyAmountofGoods: 'Amount of Goods (NZ$)',
    modifyAttachment: 'Attachments',
    modifyShippingFee: 'Shipping Fee (NZ$)',
    isRefund: 'is refund',
    orderAttachment: 'Order Attachemnts',
    operationType: 'Operation Type',
    isPickUp: 'Is Pickup',
    onlyPickUp: 'Only Pick Up',
    isAgentOrder: 'Agent Order',
    isPickUpOrder: 'Pick-up Order',
    expressCompany: 'Courier Company',
    addTrackingNumber: 'Add tracking number',
    messageToCustomer: 'Message to customer',
    orderComment: 'Order Comment',
    quantity: 'Quantity',
    orderType: 'Order Type',
    generalOrder: 'General',
    agentOrder: 'Agent',
    orderFee: 'Order Fee',
    customerRemark: 'Customer Remark',
    orderAddress: 'Delivery Information',
    orderSender: 'Sender Information',
    orderTime: 'Order Time',
    orderActivity: 'Promotion of Order',
    orderCoupon: 'Coupon of Order',
    promotionActivity: 'Promotion',
    couponActivity: 'Coupon',
    confirmSubmitOrderInfo: 'Confirm update order information',
    confirmSaveOrderInfo: 'Confirm save order information',

    // Invoice
    inclGST: 'Include GST',
    plusGST: 'Add GST Invoice',
    zeroGST: 'Zero GST Invoice(Overseas)',
    companyPhone: 'Company Phone',
    companyEmail: 'Company Email',
    companyAddress: 'Company Address',
    customer: 'Customer',
    customerNote: 'Customer Note',
    sellerComments: 'Seller Comments',
    subtotal: 'subtotal',
    totalQty: 'Total Qty',
    goods: 'Goods',
    goodsSubtotalInclGST: 'Goods Subtotal(Incl GST)',
    goodsSubtotalZeroGST: 'Goods Subtotal(Zero GST)',
    shippingFeePromotion: 'Shipping Fee Promotion',
    printReceipt: 'Print Receipt',
    printA4: 'Print A4',
    close: 'Close',
    orderInvoice: 'Order Invoice',

    // 物流信息
    shippingInfo: 'Shipping Info',
    trackShipping: 'Track Shipping',
    date: 'Date',
    addCompany: 'Add Shipping Provider',

    // 仓储中心
    sku: 'SKU',
    stockValue: 'Stock Value',
    stockOperationType: 'Stock Operation',
    stockOperationInformation: 'Stock Information',
    创建商品: 'Create Products',
    添加库存: 'Add Stock',
    直接设置Sku商品库存: 'Edit Stock of Sku Directly',
    关闭订单解锁库存: 'Close Order Stock Unlock',
    删除Sku商品: 'Delete Sku of Products',
    人工减少库存: 'Manually Reduce Stock',
    创建订单锁库存: 'Create Order Stock Lock',
    stockTimeRange: 'Time Range',
    viewAllSkuStock: 'View All Stock',
    stockBeforeValue: 'Value before edit',
    stockAfterValue: 'Value after edit',

    // 商品品牌
    brandName: 'Brand Name',
    brandLogo: 'Brand Logo',
    brandInitials: 'Brand Initials',
    sortWeight: 'Sorting Weights',
    createAt: 'Create Time',
    brandActivity: 'Brand Activity',
    brandDetails: 'Brand Details',
    brandReady: 'Show',
    brandWaitForReview: 'Wait For Review',
    brandDeletedError: 'This brand includs some goods, cannot be deleted',

    // 发货仓库
    warehouseName: 'Warehouse Name',
    warehouseAddress: 'Warehouse Address',
    warehouseDeletedError:
      'This warehouse includs some goods, cannot be deleted',

    // 商品分类
    categoriesName: 'Name',
    categoriesParent: 'Parent',
    categoriesDescription: 'Description',
    categoriesSortWeight: 'Sort Weight',
    noCategoriesParent: 'The default is the top level if do not be selected',
    menuOperation: 'Menu Operation',
    categoryIndex: 'Category Operation',
    hide: 'Hide',
    menuShow: 'Show',
    categoryIndexShow: 'Show',
    category_icon: 'Category Icon',
    topCategory: 'Top Category',
    categoryDeletedError: 'This category includs some goods, cannot be deleted',
    show: 'Show',
    pcMenu: 'PC Menu',
    pcModel: 'PC Homepage Model',
    pcHomeCategoryImage: 'PC Homepage Category Image',
    mobileCategoryImage: 'Mobile Category Image',
    customizeIcon: 'Customize Icon',
    customization: 'Customization',
    pcHomeCategoryImageSize: 'recommend image size: 210*454 (or ratio 210*454)',
    customizeIconSize: 'recommend image ratio 1:1',
    mobileCategoryImageSize: 'recommend image size: 270*85 (or ratio 270*85)',
    deleteImage: 'Delete image',
    categoryInfoNotEnough: 'Category information is not enough',

    // 用户中心
    ID: 'ID',
    loginName: 'Login Name',
    userGroup: 'User Group',
    phoneNumber: 'Phone Number',

    // 用户详情
    password: 'Password',
    confirmPassword: 'Confirm Password',
    root: 'Root',
    manager: 'Manager',
    pleaseSelectAUserRole: 'Please Select a User Role',
    create: 'Create',
    update: 'Update',

    // 店铺中心
    shopLogo: 'Shop Logo',
    shopName: 'Shop Name',
    shopType: 'Shop Type',
    shopUrls: 'Shop Urls',
    shopActivity: 'Shop Status',
    shopReady: 'Ready',
    shopWaitForReview: 'Pending',
    oldPassword: 'Old Password',

    // 店铺详情
    merchantName: 'Merchant Name',
    merchantAddress: 'Merchant Address',
    merchantContactPhone: 'Merchant Contact Phone',
    merchantContactEmail: 'Merchant Contact Email',
    merchantContactPerson: 'Merchant Contact Person',
    accountManager: 'Account Manager',
    accountManagerMobilePhone: 'Account Manager Mobile Phone',
    district: 'District',
    changePassword: 'Change Password',
    editPassword: 'Change Password',
    newPassword: 'New Password',
    cancelPassword: 'Cancel Password',
    submitPassword: 'Submit Password',
    contactInfo: 'Contact Info',
    customerServiceWxId: 'Customer Service Wechat ID',
    shopProfile: 'Shop Profile',
    shopDetailsInstroduce: 'Shop Details',
    pleaseChooseShopType: 'Please choose shop type',
    company: 'Company',
    personal: 'Personal',
    wx_appid: 'Wechat App ID',
    shopPaymentDetail: 'Offline Payment Details',
    welcomeImage: 'Welcome Image',
    oa_token: 'Wechat Official Account Recall Token',
    shopQr: 'Shop QRcode',
    tongUrl: 'Synchronous Callback URL',
    yiUrl: 'Asynchronous Callbacks URL',
    uiTemplate: 'UI template',
    selectUiTemplate: 'UI template',
    shopCustomHost: 'Custom Host',
    contactIemall: 'Please contact Customer Service to edit it',
    exportGoods: 'Export Goods',
    importGoods: 'Import Goods',
    exportGoodsAsXLSXFormat: 'Export as XLSX Format',
    importFormatSameAsExport: 'Import Format Should be consistent with Export',
    searchHotKey: 'Search Hot Key',
    addSearchHotKey: 'Add hot key',
    clickHotKey: 'Click hot key to top',
    myPayMid: 'IE PAY Mid',
    myPayApiKey: 'IE PAY Api Key',
    haveIepayAccout: 'If you already have IE PAY account, please login Merchant Admin System ',
    getMid: ', go to "Merchant Information" - "Online" to get IE PAY Mid.',
    getApikey: ', go to "Merchant Information" - "Online" to get IE PAY Api Key.',
    getMidTitle: 'Get IE PAY Mid',
    getApikeyTitle: 'Get IE PAY Api Key',
    shopPlan: 'Shop Plan Detail',
    memberPlan: 'Shop Member Plan',
    memberPlanApply: 'Member Plan Modify Application',
    memberPlanInfo: 'Less than half a month will be charged according to the new plan, full half month will be charged according to the old plan',
    applySuccessfully: 'Apply Successfully',
    applyFailed: 'Apply Failed',
    importExcel: 'Import/Export Excel',
    importFromPos: 'Import Goods from POS',
    importCategories: 'Import Categories',

    // 物流中心
    templateName: 'Template Name',
    pricingMethod: 'Pricing Method',
    defaultValue: 'Default Value',
    defaultPrice: 'Default Price',
    byWeight: 'By Weight',
    nzDefaultPrice: 'NZ$ price',
    cnDefaultPrice: 'RMB¥ price',
    everyG: 'Every (g)',
    shippingCosts: 'Shipping Costs',
    everyGAdded: 'Every (g) Added',
    shippingCostsAdded: 'Shipping Costs Added',
    minPackageWeight: 'Min Package Weight(Kg)',
    feePerQuantity: 'Shipping Fee per Kg',
    packageType: 'Package Type',
    packageRuleType: 'Package Rule Type',
    value: 'Value',
    addRule: 'Add Value',
    companyStatus: 'Company Status',
    companyName: 'Company Name',

    // 商品中心
    merchandiseId: 'ID',
    merchandiseThumbnail: 'Thumbnail',
    merchandiseName: 'Name',
    merchandisePrice: 'Sold Price',
    merchandiseSortWeight: 'Sort Weight',
    merchandiseActivity: 'Activity',
    merchandiseRecommend: 'Recommend',
    StockOperation: 'Stock Operate',
    inStock: 'Edit Stock',
    editStock: 'Edit Stock',
    productName: 'Product Name',
    stock: 'Stock',
    stockAlarm: 'Stock Alarm',
    priceMarketNz: 'Market Price (NZ$)',
    priceSoldNz: 'Selling Price (NZ$)',
    priceMarket: 'Market Price (RMB¥)',
    priceSold: 'Selling Price (RMB¥)',
    cancel: 'Cancel',
    deleteProduct: 'Delete the product?',
    isStockAlarm: 'Stock Alarm',
    deleteWarehouse: 'Delete the warehouse?',
    warehouseDeleted: 'Warehouse Deleted',
    warehouseDeletedFailed: 'Warehouse Deletion failed',
    batchDeleteProducts: 'Delete Selected Products',
    batchManageFreeShipping: 'Manage selected free shipping',
    batchManagePriceBreakDiscount: 'Manage Price Break Discount',
    batchManageAgentVisibility: 'Manage selected agent visibility',
    batchManageFreeGift: 'Manage Free Gift',
    PriceBreakPromotion: 'Price Break Promotion',
    basePrice: 'Base Price',
    freeShippingPromotion: 'Free Shipping Promotion',
    nonFreeShipping: 'Non Free Shipping',
    freeShipping: 'Free Shipping',
    onOff: 'On or Off',
    all: 'All',
    on: 'On',
    off: 'Off',
    soldOut: 'Sold Out',
    freeGift: 'Free Gift',
    priceAsc: 'Price Ascending',
    priceDesc: 'Price Descending',
    promotion: 'Promotion',
    stockDetail: 'Stock Detail',
    batchEditPrice: 'Batch Edit Price',
    batchEditStock: 'Batch Edit Stock',
    batchSetStockAlert: 'Batch Set Stock Alert',
    batchEditLimitTime: 'Batch Set Limited Time Discount',
    updateSelectedGoods: 'Update Selected Goods As',
    confirmUpdateSelectedGoods: 'Confirm Update Select Goods as',
    updateSelectedGoodsNoPriceBreak: 'Update Selected Goods as No Price Break',
    updateSelectedGoodsFreeGift: 'Update Selected Goods as Free Gift',
    updateSelectedGoodsNoFreeGift: 'Update Selected Goods AS No Free Gift',
    updateSelectedGoodsAgentVisible: 'Update Selected Goods as Agent Visible',
    updateSelectedGoodsAgentInvisible:
      'Update Selected Goods as Agent Invisible',
    updateSelectedGoodsBestUseBeforeAt: 'Batch update selected goods shelf life',
    confirmUpdateSelectedGoodsNoPriceBreak:
      'Confirm Update Selected Goods as No Price Break',
    confirmUpdateSelectedGoodsPriceBreak:
      'Confirm Update Selected Goods as Price Break',
    confirmUpdateSelectedGoodsNoFreeGift:
      'Confirm Update Selected Goods as No Free Gift',
    confirmUpdateSelectedGoodsAgentVisible:
      'Confirm Update Selected Goods as Agent Visible',
    confirmUpdateSelectedGoodsAgentInvisible:
      'Confirm Update Selected Goods as Agent Invisible',
    confirmUpdateSelectedGoodsBestUseBeforeAt: 'Confirm batch update selected goods shelf life',
    pleaseChooseProducts: 'Please Choose Products',
    perPage: 'Per Page',
    pleaseInputNZDMarketPrice: 'Please Input NZD Market Price',
    pleaseInputCNYMarketPrice: 'Please Input CNY Market Price',
    pleaseInputNZDSalePrice: 'Please Input NZD Sale Price',
    pleaseInputCNYSalePrice: 'Please Input CNY Sale Price',
    pleaseInputCorrectStock: 'Please Input Correct Stock',
    pleaseInputCorrectStockAlert: 'Please Input Correct Stock Alert',
    successDeleted: 'Deleted Successfully',
    successUpdated: 'Updated Successfullyy',
    pleaseChooseFreeShippingPromotion: 'Please Choose Free Shipping Promotion',
    pleaseChoosePriceBreakPromotion: 'Please Choose Price Break Promotion',
    specialPriceExpiredAsc: 'Special Price Expired',
    batchManageCoupon: 'Batch Manage Coupon',
    updateSelectedGoodsCouponEnabled: 'Update Selected Goods as Coupon Enabled',
    updateSelectedGoodsCouponDisabled:
      'Update Selected Goods as Coupon Disabled',
    confirmUpdateSelectedGoodsCouponEnabled:
      'Confirm Update Selected Goods as Coupon Enabled',
    confirmUpdateSelectedGoodsCouponDisabled:
      'Confirm Update Selected Goods as Coupon Disabled',
    batchSpecialPrice: 'Batch Special Price',
    batchManageSold: 'Batch Manage Sold',
    batchManagePromote: 'Batch Manage Promote',
    batchUpdateBestUseBefore: 'Batch update best use before dates',
    batchUpdateSpecialPrice: 'Batch edit special price',
    updateSelectedGoodsEnableSold: 'Update Selected Goods as Sold Enabled',
    updateSelectedGoodsDisableSold: 'Update Selected Goods as Sold Disabled',
    updateSelectedGoodsEnablePromote:
      'Update Selected Goods as Promote Enabled',
    updateSelectedGoodsDisablePromote:
      'Update Selected Goods as Promote Disabled',
    confirmUpdateSelectedGoodsSoldEnable:
      'Confirm Update Selected Goods as Sold Enabled',
    confirmUpdateSelectedGoodsSoldDisable:
      'Confirm Update Selected Goods as Sold Enabled',
    confirmUpdateSelectedGoodsPromoteEnable:
      'Confirm Update Selected Goods as Promote Enabled',
    confirmUpdateSelectedGoodsPromoteDisable:
      'Confirm Update Selected Goods as Promote Enabled',
    pickUpOnlyWarning:
      'For Group buy goods only, enable this will result in the product can only be purchased separately and pick-up only',
    haveExpired: 'Expired',
    removePropertyItem: 'Remove Property to Single Product',

    // 添加商品
    chooseCategory: 'Select Category',
    basicInformation: 'Basic Information',
    merchandiseDetails: "Products' Details",
    merchandiseAttributes: "Products' Attributes",
    merchandiseAlbum: "Products' Images",
    distributionSettings: 'Distribution Settings',
    otherInformation: 'Extra Information',
    productSubtitle: 'Subtitle',
    productAbbreviation: 'Product Abbreviation',
    selectedCategories: 'Category',
    productBrand: 'Brand',
    shippingWarehouse: 'Warehouse',
    noData: 'No data',
    shippingMethod: 'Shipping Method',
    measurement: 'Unit',
    enterMeasurement:
      'Enter the unit of measure, for example, cans, bags, bottles, boxes, etc.',
    productSPUWeight: 'SPU Weight',
    productSKUWeight: 'SKU Weight',
    syncPosData: 'sync POS Stock',
    SpuWeightNotice: 'SPU Weight will be used if no SKU weight',
    gram: 'Gram',
    bestUseBefore: 'Expiry Date',
    Latest: 'Latest',
    keyword: 'Keyword',
    productStock: 'Product Stock',
    productSku: 'SKU',
    option: 'Option',
    topButton: '  Top',
    deleteButton: 'Delete  ',
    level1: 'Points of Level 1',
    level2: 'Points of Level 2',
    level3: 'Points of Level 3',
    selling: 'Selling',
    recommended: 'Recommended',
    createProduct: 'Create',
    finish: 'Finish',
    next: 'Next',

    // 商品列表
    reset: 'Reset',
    goodsReady: 'Already',
    goodsWaitForReview: 'Discontinued',
    recommend: 'Recommended',
    notRecommended: 'Not recommended',
    merchandiseStock: 'Stock',
    goodsSort: 'Goods Sort',
    pleaseChoose: 'Please Choose',

    // CMS
    moduleName: 'CMS Module Name',
    moduleActivity: 'Module Actitvity',
    moduleReady: 'Show',
    moduleWaitForReview: 'Hide',

    // 提示信息
    switchLanguageSuccess: 'Switch Language Success',

    // 内容中心
    enable: 'Enable',
    sort: 'Sort',
    navigateName: 'Navigate Name',
    bannerActivity: 'Mobile Status',
    bannerTitle: 'Banner Title',
    agentName: 'Agent Name',
    bannerImg: 'Banner Img',
    linkUrl: 'Url',
    actionUrl: 'Mobile Action URL',
    bannerImage: 'Banner Image',
    relatedCategories: 'Related Category',
    dragFiles: 'Drag files here or',
    uploadFiles: 'Upload',
    fileLimit: 'Can only upload jpg/png files up to 2mb',
    lessThan2MB: 'File must be less than 2MB',
    deleteBanner: 'Delete the Banner?',
    noticeConfirm: 'Confirm',
    deleteCancel: 'Cancel',
    deleteConfirm: 'Confirm',
    deletePage: 'Delete the Page?',
    pageName: 'Page Name',
    loginEmail: 'Login Email',
    shopDomain: 'hop Domain',
    pageTitle: 'Title',
    pageSuffix: 'Url Suffix',
    pageStatus: 'Status',
    pageDetail: 'Page Detail',
    // bannerActivity: 'Banner状态',
    bannerReady: 'Banner Ready',
    bannerWaitForReview: 'Banner Wait For Review',
    relatedTo: 'Related To',
    relatedBrands: 'Related Brands',
    relatedSearch: 'Search Keywords',
    relatedCustomize: 'Related Customize',
    uploadFilesSize: 'Recommend Banner Size: 1000*384(Or ratio 125:48)',
    aboutUsImgSizeNotice: 'Recommend Banner Size: 100(width) * 80(height)',
    relatedActivity: 'Related Activity',
    activityUrl: 'Activity Url',
    showInStoreWiki: 'Show in StoreWiki',
    pageUrl: 'Page URL',
    pcActionUrl: 'PC Action Url',
    bannerPCActivity: 'PC Status',
    hotSalesImageSize: 'recommend image ratio 1:1',

    // 搜索
    inputSearch: 'Merchandise',
    searchInfo: 'Name/ID',
    merchandiseCategories: 'Category',
    merchandiseBrand: 'Brand',
    selectBrand: 'Brand',
    searchSubmit: 'Search',

    // 交易中心
    transactionId: 'Transaction Id',
    orderTitle: 'Title',
    createTime: 'Created Time',
    finishTime: 'Finished Time',
    paymentStatus: 'Status',
    customerName: 'Customer Name',
    paymentAmount: 'Amount',
    paymentType: 'Type',

    // 分销中心
    distributionId: 'Distribution Id',
    distributionLevel: 'Distribution Level',
    distributionPoint: 'Distribution Point',
    distributionSuperior: 'Superior Username',
    distributionSubordinate: 'Subordinate Username',
    productSuperior: 'Superior Product',
    productSubordinate: 'Subordinate Product',
    type: 'Type',
    agentMsg1:
      'Current in beta, policy and pricing plan will be available when this module officially public. Exist store will be restricted if you ignore this.',
    accountMoreThan6Characters:
      'Account should be more than 6 characters or number',

    // 会员中心
    memberIdSearch: 'ID/Username',
    enterMemberId: 'Member ID/Username',
    memberNameSearch: 'Member Name',
    enterMemberName: 'Member Name',
    registrationDateSearch: 'Registration Date',
    enterRegistrationDate: 'Registration Date',
    memberId: 'Member ID',
    username: 'Username',
    memberName: 'Member Name',
    memberLevel: 'Member Level',
    memberPoint: 'Member Point',
    totleAmount: 'Totle Amount',
    orderQuantity: 'Order Quantity',
    registrationDate: 'Registration Date',
    memberDetail: 'Member Details',
    memberOrder: 'Members’ Orders',
    onlyShowBenchmarkCurrency: 'Only Show Benchmark Currency',
    customerMustBindEmailOrPhone: 'Customer account must bind email or phone number',
    allowPickUp: 'Allow Pick-up',
    allowShipping: 'Allow Shipping',
    isShowSender: 'Show Sender',
    isAgeRestriction: '18 + Age Restriction',
    businessScope: 'Business Scope',
    International: 'Global',
    newZealand: 'New Zealand',
    disableShippingNotice:
      'Disable this if you only allow orders to be collected by customer',
    isShowCourierWeight: 'Display Product Weight',
    pickUpOrShipping:
      'Pickup and shipping options cannot be off at the same time',
    idRequired: 'ID Required',
    deleteEnable: 'Delete Enable',
    canDelete: 'Can Delete',
    cannotDelete: "Can't Delete",
    wechatImg: 'Wechat Portrait',
    wechatName: 'Wechat',
    editCreditButton: 'Edit Credit',
    addCredit: 'Add Credit',
    reduceCredit: 'Reduce Credit',
    comment: 'Comment',
    sortByTotalOrderSum: 'Sort By Order Value',
    PeriodtotalSpend: 'Total Spending',
    PeriodtotalOrders: 'Total Orders',
    successSpend: 'Successful Spending',
    successOrders: 'Successful Orders',
    couponBatchIssued: 'Coupon Batch Issued',
    couponBatchIssueFailed: 'Coupon Batch Issue Failed',
    userRemarks: 'User Remarks',
    editUserRemarks: 'Edit User Remarks',
    level: 'Level',
    name: 'Name',
    editName: 'Edit Name',
    levelName: 'Level Name',
    save: 'Save',
    editLevel: 'Edit Level',
    editCredit: 'Edit Credit',
    memberCreditEdit: 'Member Credit Edit',
    creditOperationLog: 'Credit Operation Log',
    creditAmount: 'Credit Amount',
    totalAmount: 'Total Amount',
    memberCredit: 'Member Credit',
    createPlan: 'Create Plan',
    miniProgramInfo: 'WeChat Mini Program Info',
    青铜: 'Level 1',
    白银: 'Level 2',
    黄金: 'Level 3',
    铂金: 'Level 4',
    钻石: 'Level 5',
    星耀: 'Level 6',
    王者: 'Level 7',

    // 店员中心
    assistantId: 'Assistant ID',
    phone: 'Phone',
    email: 'Email',
    role: 'Role',
    createdAt: 'Created At',
    addRole: 'Add Role',
    editAssistant: 'Edit Assistant',
    editAssistantDetail: 'Edit Assistant Detail',
    writerList: 'Writer',
    useDifferentName: 'Error! Please try use different name',
    englishOnly: 'Use English characters only',

    // 店员权限
    roleName: 'Role Name',
    passwordUnmatch: 'The Password Do Not Match',
    passwordCanNotBeEmpty: 'Password Can Not Be Empty',
    RoleDuplicate: 'Role Already Exist!',
    roleDescription: 'Role Description',
    订单管理员: 'Orders administrator',
    商品管理员: 'Merchandise administrator',
    仓储中心查询: 'Stock enquiry',
    内容管理: 'CMS management',
    店铺基础信息管理员: 'Shop basic information administrator',
    '会员管理员(无余额）': 'Members administrator(No balance)',
    店员权限管理: 'Assistant permission management',
    订单查询: 'Order enquiry',
    物流管理员: 'Express administrator',
    代理管理: 'Agent management',
    优惠券管理: 'Coupon management',
    '会员管理员(余额）': 'Members administrator(balance)',
    交易查询: 'Transaction enquiry',
    '管理订单、配货、发货、退款和查询功能': 'Manage orders, distribution, delivery, refund and query functions',
    '管理品牌、商品分类、发货仓库、商品管理、入库管理。': 'Manage brand, product classification, shipping warehouse, product management, and warehousing management.',
    '查询商品出入库记录。': 'Query the record of goods in and out of the warehouse.',
    '店铺内容管理和banner管理。': 'CMS management and banner management.',
    '管理店铺基础信息维护': 'Manage store basic information maintenance',
    '管理会员等级、折扣方案、会员等级': 'Manage member levels and discount plans',
    '添加店员，管理店员权限、查询角色权限': 'Add shop assistants, manage shop assistant permissions, query role permissions',
    '只能看到已付款和已发货订单，并能编辑订单状态。': 'Only see paid and shipped orders, and edit the order status.',
    '管理物流公司、快递模板': 'Manage courier companies and express templates',
    '添加代理和管理代理返佣': 'Add agent and manage agent rebate',
    '编辑会员余额': 'Edit member balance',
    '交易查询流水列表': 'Transaction query, running list',

    // 核销
    writerId: 'Writer ID',
    writerName: 'Writer name',
    writerCode: 'Writer code',
    writerLog: 'Writer log',
    editWriter: 'Edit',
    editWriterDetail: 'Edit Writer Information',
    addWriter: 'Add Writer',
    codeIsNumber: 'Writer code should be four numbers',
    fourNumber: 'Four numbers',

    // 统计中心
    dataUpdatedAt: 'Data Updated At',
    statisticsNotice: 'Time Format: UTC+08',
    keyIndicator: 'Key Indicator',
    totalToday: 'Total Today',
    totalYesterday: 'Total Yesterday',
    totalThisMonth: 'Total Current Month',
    totalPrevMonth: 'Total Prev Month',
    trend: 'Trend',
    detailData: 'Detail Data',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    creditPay: 'Credit Pay',
    onfflinePay: 'Offline Pay',
    PoliPay: 'PoliPay',
    UnionPay: 'UnionPay',
    refundAmount: 'Refund Amount',
    totalSales: 'Total Sales',
    totalOrdersToday: 'Total Orders Today',
    totalOrderYesterday: 'Total Orders Yesterday',
    totalOrderCurrentMonth: 'Total Orders Current Month',
    totalOrderPrevMonth: 'Total Orders Prev Month',
    orderPlaced: 'Order Placed',
    orderPaid: 'Orders Paid',
    orderPayRate: 'Order Pay Rate',
    averageOrderValue: 'Average Order Value',
    topOrderValue: 'Top Order Value',
    statisticsDuration: 'Statistics Duration',
    thirtydaysSales: '30 Days Sales',
    historicalSales: 'Historical Sales',
    searchGoods: 'Search Goods',
    goodsImage: 'Goods Image',
    salesVolume: 'Sales Volume',
    salesRank: 'Sales Rank',
    newMemberToday: 'New Members Today',
    newMemberYesterday: 'New Members Yesterday',
    newMemberCurrentMonth: 'New Members Current Month',
    totalMembers: 'Total Members',
    newMemberCount: 'New Registered Member',

    // 活动中心
    promotionGoodsListUrl: 'Mobile Promotion Goods URL',
    freeShippingGoodsListUrl: 'Mobile Free Shipping Goods URL',
    promotionDetail: 'Promotion Detail',
    confirmDelete: 'Confirm Delete?',
    endDate: 'End Date',
    onlyShowsFreeShippingGoods: 'Only Shows Free Shipping Goods',
    onlyShowsLimitFreeShippingGoods: 'Only Shows Limit Free Shipping Goods',
    limitFreeShippingUrl: 'Mobile Limit Free Shipping URL',
    freeShippingName: 'Free Shipping Promotion Name',
    freeShippingCap: 'Free Shipping Cap',
    spendMoreThan: 'When you spend more than NZD $',
    willBeFreeShipping: ' It will be free shipping',
    deductNZD: 'Deduct NZD $',
    promotionName: 'Promotion Name',
    reach: 'Reach',
    reduce: 'Reduce',
    enterFullReductionCondition: 'Please Enter Full Reduction Conditions',
    promotionGoodsListPCUrl: 'PC Promotion Goods URL',
    pcFreeShippingGoodsListUrl: 'PC Free Shipping Goods URL',
    pcLimitFreeShippingUrl: 'PC Limit Free Shipping URL',

    // 运营中心
    isDeleteEnable: 'Deletable?',
    promotionCenter: 'Promotion Center',
    gift: 'Free Gift',
    limitedTimeSpecial: 'Limited Time Special',
    couponCollectCenter: 'Coupon Center',

    // 支付方式
    wechatPay: 'Wechat Pay',
    alipay: 'Alipay',
    polipay: 'POLi',
    creditCard: 'Credit Card',
    bankTransfer: 'Bank Transfer',
    alipayQrCode: 'Alipay QR Code',
    alipayOnline: 'Alipay Online支付宝网页',
    alipayMobileOnline: 'Alipay Mobile Online',
    wechatQrCode: 'Wechat QR Code',
    wechatMobileOnline: 'Wechat Mobile Online',
    wechatPremiumPay: 'Wechat Premium Pay',
    unionpay: 'UnionPay',
    paypal: 'PayPal',

    // 代理商
    withdrawDetail: 'Withdraw Detail',
    newAgent: 'New Agent',
    editAgent: 'Edit Agent',
    initPassword: 'Initial Password',
    contactPerson: 'Contact Person',
    contactPhone: 'Contact Phone',
    contactWechat: 'Contact Wechat',
    digitalWallet: 'Digital Wallet',
    active: 'Active',
    contactAddress: 'Contact Address',
    domainPrefix: 'Domain Prefix',
    agentLevel: 'Agent Level',
    agreePolicy: 'Agree Policy',
    distributorAgreement: 'Agent Agreement',
    agentProfit: 'Agent Profit',
    withdrawAmount: 'Withdraw Amount',
    balance: 'Balance',
    status: 'Status',
    agentApplication: 'Agent Application',
    agentApplicationUrl: 'Agent Application Url',
    selectOrUploadLogo: 'Select or upload logo',
    agentNotice: 'This is Beta version',
    compulsory: '* are compulsory section',
    defaultAgentLoginURL: 'Default Agent Login URL:',
    shopURL: 'Shop URL',
    allDocs: 'All Documents',
    clickToUpload: 'Click to Upload',
    finalizeWithdraw: 'Finalize Withdraw',
    withdrawNotice1:
      'Please upload proof of transfer before click Transfer, to confirm the withdras has done',
    withdrawNotice2:
      'Please contact IE MONEY for money remittance if you need any help(within 3 working days)',
    withdrawNotice3:
      'You sure you want to send these info to the customer representative of IE MONEY, they will contact you shortly for more detail',
    markAsPaid: 'Mark as Paid',
    confirmFinalizeWithdraw: 'Confirm Finalize Withdraw?',
    agentUsername: 'Agent Name',
    viewDetail: 'View Detail',
    address: 'Address',
    // 电子钱包
    time: 'Time',
    contactEmail: 'Contact Email',

    // 优惠券
    coupon: 'Coupon',
    createNewCoupon: 'Create New Coupon',
    collectCoupon: 'Mobile Coupon Center',
    pcCollectCoupon: 'PC Coupon Center',
    couponName: 'Coupon Name',
    couponExpiryTime: 'Coupon Expiry Date',
    couponCode: 'Coupon Code',
    effectiveTime: 'Effective Time',
    couponType: 'Coupon Type',
    numberOfIssues: 'Number of Issue',
    couponDetails: 'Coupon Details',
    showInCollection: 'Show in Coupon Center',
    couponRemark: 'Remark',
    details: 'Details',
    newCoupon: 'New Coupon',
    collectCouponUrl: 'Mobile Coupon Collection Url',
    pcCollectCouponUrl: 'PC Coupon Collection Url',
    couponCondition: 'Condition of Coupon',
    couponDeduction: 'Coupon Deduction',
    couponDiscount: 'Coupon Discount',
    couponEffectiveDate: 'Effective Date',
    endCoupon: 'End Coupon',
    couponTotalNumber: 'Number of Issue',
    unlimitedNumber: 'Unlimited if No Input',
    collectedCoupon: 'Number of Collected',
    usedCoupon: 'Number of Used',
    numberPerCustomer: 'Limited Number of Per Customer',
    isShowedInCollection: 'Show in Coupon Center',
    autoCode: 'Auto if No Input',
    numberOfCollect: 'Number of Collected',
    numberOfUsed: 'Number of Used',
    averagePrice: 'Average Price of Orders Used Coupon',
    sumOfOrder: 'Sum of Orders Used Coupon',
    couponOrder: 'Orders List of the Coupon',
    priceOfOrder: 'Order Price',
    deduction: 'Deduction',
    discount: 'Discount',
    infoCondition: 'Orders over NZD $',
    infoDeduction: 'reduce',
    infoDiscount: 'Is',
    infoSale: 'Off',
    deductionCondition: 'Cannot over condition',
    discountCondition: 'The discount should be between 0.01 and 0.99',
    couponEnabled: 'Status',
    selectCoupon: 'Select coupon',
    sendCoupon: 'Send coupon',
    pleaseChooseMembers: 'Please select members',
    discountTip: 'E.g. Input 0.8 means 20% off',
    deleteCoupon: 'Confirm to delete the coupon?',

    // 公告中心
    updatedAt: 'Updated At',
    noticeContent: 'Notice Content',
    deleteNotice: 'Delete the notice?',
    addNotice: 'Add Notice',
    updateNotice: 'Update Notice',
    // 保质期
    bestUseAt: 'Best Use At',
    to: 'To',
    startDate: 'Start Date',
    iemallGuide: 'Shop Guide',
    post: 'Post',
    selfOperated: 'Self-operated',
    expressContext: 'Details',
    expressTime: 'Time',
    tradeNo: 'Order number',
    queryUrl: 'Express company official website',
    includeShippingAddress: 'Include Shipping Address',
    recipientName: 'Recipient Name',
    batchOperation: 'Batch operation',
    discountPlan: 'Discount Plan',
    expressTemplate: 'Express Template',
    productLength: 'Product Length',
    productWidth: 'Product Width',
    productHeight: 'Product Height',
    productProperty: 'Product Property',
    addPropertyItem: 'Add Property Item',
    skuWeight: 'Goods Shipping Weight',
    isCredit: 'Allow balance payments',
    isAlone: 'Only alone pay',
    isAgentVisible: 'Allow agents to be visible',
    addProductProperty: 'Add Product Property',
    productPropertyName: 'Property Key',
    productPropertyValue: 'Property Value',
    createDiscountPlan: 'Create Discount Plan',
    chooseShelfLife: 'Choose shelf life',
    optionShelifLife: '(Optional, default is "latest" if null)',
    defaultSales: 'Default sales',
    defaultViews: 'Default views',
    actualSales: 'Actual sales',
    actualViews: 'Actual views',
    displaySales: 'Display sales',
    displayViews: 'Display views',
    expressType: 'Express Type',
    clickUpload: 'Upload',
    limitedTimeSpecialDeadline: 'Limited time special deadline',
    chooseDate: 'Choose Date',
    eventHasExpired: 'Event has expired',
    return: 'Return',
    isThereAGiveaway: 'Is there a giveaway',
    registrationDateRange: 'Registration Date Range',
    batchExportMemberInfo: 'Export user information in batches',
    wechatInfo: 'Wechat Info',
    wechatNickname: 'Wechat Nickname',
    wechatSex: 'Gender',
    wechatMale: 'Male',
    wechatFemale: 'Female',
    wechatUnknown: 'Unknown',
    country: 'Country',
    province: 'Province',
    city: 'City',
    pleaseSelectMembers: 'Please Select Members',
    warning: 'Warning',
    isDefault: 'Is it default',
    selectDefault: 'Select Default',
    selectDefaultCompany: 'Select Default Company',
    deleteExpressCompany: 'Delete Express Company',
    defaultCompany: 'Default Company',
    addNew: 'Add New',
    emailIsVerified: 'Email is verified',
    emailIsNotVerified: 'Email is not verified',

    refund2Credits: 'refund all to credits',
    refund2OPM: 'refund to original payment method',
    refund2Offline: 'refund offline',
    refundType: 'refund type',
    MyPayAccountBalanceNotEnough: 'MyPAY Account Balance not enough',
    DirectionOnMyPayAccountBalanceNotEnough: 'Please top up MyPay balance',

    MyPayRefundFailedInsufficientFunds: 'Refund failed, MyPay account insufficient funds',
    DirectionOnMyPayInsufficientFunds: 'Please top up MyPay balance',
    PayPalRefundFailedInsufficientFunds: 'Refund failed, PayPal account insufficient funds',
    DirectionOnPayPalInsufficientFunds: 'Please top up PayPal balance',

    OperationSucceed: 'operation succeed',

    未付款: 'Unpaid',
    部分付款: 'Partialy Paid',
    '已付款（待发货）': 'Paid (to be shipped)',
    配货中: 'Picking',
    '已发货（待完成）': 'Shipped (to be completed)',
    '未付款已发货（待完成）':
      'Outstanding payment has been shipped (to be completed)',
    交易完成: 'Transaction complete',
    用户取消订单后关闭: 'User closes after canceling the order',
    退款完成后关闭: 'Closed after refund completed',
    管理员关闭订单并退款: 'Administrator closes the order and refunds',
    管理员关闭订单: 'Administrator closes the order',
    支付超时关闭订单: 'Payout closes the order',
    已关闭: 'Closed',
    print: 'Print',

    // 通知管理
    商户: 'Merchant',
    客户: 'Customer',
    分销商: 'Distributor',
    创建订单: 'Order Created',
    支付订单: 'Order Paid',
    申请退款: 'Requested for refund',
    退款完成: 'Refund completed',
    拒绝退款: 'Refund declined',

    // banking
    bankingSolutions: 'Banking Solutions'
  },
  tagsView: {
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  dashboard: {
    店铺链接: 'Shop Link',
    快捷功能: 'Shortcut Function',
    店铺管理: 'Shop Setting',
    产品管理: 'Products',
    产品分类: 'Category',
    订单中心: 'Orders',
    仓储管理: 'Warehouse Management',
    Banner管理: 'Hero Images',
    首页推荐: 'Feature Items',
    运营中心: 'Site Operations',
    新增会员: 'New Members',
    新增订单: 'New Orders',
    收入: 'Revenue',
    今日新增会员数: 'Today',
    昨日新增会员数: 'Yesterday',
    今日订单数: 'Today',
    昨日订单数: 'Yesterday',
    今日收入: 'Today',
    昨日收入: 'Yesterday',
    会员数量: 'Members',
    商品数量: 'Items',
    订单数量: 'Orders',
    查看详情: 'Details',
    销售统计: 'Turnover',
    日期: 'date',
    本月销售总额: 'Current Month',
    同比上月: 'Than previous month',
    本周销售总额: 'Current Week',
    同比上周: 'Than previous week',
    商品受欢迎统计: 'Popular Items',
    最近订单统计: 'Recent Orders',
    今日: 'Today',
    最近30天: '30 Days',
    最近10笔: '10 Orders',
    最近20笔: '20 Orders',
    商品名称: 'Item',
    收藏量: 'Likes',
    成交次数: 'Sold',
    订单编号: 'Order ID',
    订单状态: 'Status',
    订单金额: 'Amount',
    开始日期: 'start date',
    结束日期: 'end date',
    至: 'to',
    请完成开户: 'Please finish your account opening progress first',
    完成: 'Done',
    关闭: 'Close',
    上一步: 'Prev',
    下一步: 'Next',
    driver1Name: 'How to create new goods',
    driver1Desc: 'Click this icon to enter the commodity management interface to create a commodity. Before creating a commodity, please create the corresponding classification and brand of the commodity',
    driver2Name: 'How to create new brand',
    driver2Desc: 'Click this icon to enter the brand management interface for brand creation',
    driver3Name: 'How to create new Classification',
    driver3Desc: 'Click this icon to enter the classification management interface to create a classification',
    手机端链接: 'Mobile Url',
    电脑端链接: 'PC Url',
    自定义链接: 'Custom Url',
    操作手册链接: 'Guide Url',
    手机端二维码: 'Mobile QRcode',
    复制: 'Copy',
    复制成功: 'Copy successfully'
  },
  openShop: {
    null: 'null',
    零售业基础方案: '\nRetail Entry solution plan. <br /> \nContain internet service & payment software and hardware. <br />',
    零售业高级方案: `Contain internet service & high-performance payment software and hardware.<br />`,
    服务业基础方案: 'Contain internet service & payment software and hardware.<br />',
    服务业高级方案: 'Contain internet service & high-performance payment software and hardware.<br />',
    MieWirelessinternet52Unlimited_str: 'Wireless Network Service',
    MieWirelessinternet52Unlimited: 'Mie Wireless internet 5/2 Unlimited.<br/5MB/S Unlimited data network service.<br />\nFor small / middle business.<br />',
    SUNMID2sLite_str: `Order Screen`,
    SUNMID2sLite: `SUNMI D2s Lite.<br/>SUNMI 15.6' smart desktop terminal.<br />\nGreat performance & outlook.<br />`,
    TaptouchS300H_str: `Printer`,
    TaptouchS300H: `Taptouch S300H.<br/>Taptouch thermal printer.<br />\nSupport Windows, Android & Linux.<br />`,
    TaptouchC3540_str: `Cash-Drawer`,
    TaptouchC3540: `Taptouch  C3540.<br/>Taptouch cash-drawer(40cm*35cm).<br />\nEnough space and long life.<br />`,
    TaptouchN2050_str: `Scanner`,
    TaptouchN2050: `Taptouch N2050.<br/>Taptouch desktop scaner.<br />\nEasy & fast scan the code.<br />`,
    HospitalityFastGrow_str: `POS System`,
    HospitalityFastGrow: `Hospitality Fast Grow.<br/>Taptouch for Café, Take Away and Quick Serve, or Restaurant POS system.<br />`,
    MieWirelessinternet205Unlimited_str: `Wireless Network Service`,
    MieWirelessinternet205Unlimited: `Mie Wireless internet 20/5 Unlimited.<br/>20MB/S Unlimited data network service.<br />\nFor middle / large business.<br />`,
    SUNMIT2sDualTouch_str: `Order Screen`,
    SUNMIT2sDualTouch: `SUNMI T2s Dual Touch.<br/>SUNMI smart desktop terminal with two screens(15.6' main + 10.1' customer).<br />\nGreat performance & outlook.<br />`,
    SmartBox_str: `Inspiry Smart Box`,
    SmartBox: `Inspiry Smart Box.<br />\nWhole payment system within.<br />`,
    选择套餐: 'Select Plan',
    选择模板: 'Select Template',
    选择支付渠道: 'Select Payment-method',
    选择商品: 'Point of sale Solution',
    结算: 'Pay',
    成功提交: 'Success',
    确定: 'OK',
    以下是官方套餐推荐服务选择: 'Feature Solution Plans',
    官方根据各个场景专业化推荐套餐: 'Officials recommend professional packages according to each scenario',
    以下是个性化服务选择: 'Please Choose your custom Point of Sale Solutions',
    可根据自己店铺所需个性化定制: 'Can be customized according to their own shop needs',
    套餐介绍: 'introduction of the plan',
    系统介绍: 'system introduction',
    查看介绍: 'Details',
    POS系统: 'POS System',
    POS硬件机: 'POS hardware',
    EFPOS系统: 'EFTPOS',
    配件: 'Accessories',
    需线下支付: 'Offline payment is required',
    网络服务: 'Internet Services',
    线下商品支付: 'Offline Solution payment',
    绑定的支付渠道: 'Bound payment channels',
    已选模板: 'The selected template',
    已选商品: 'The selected Solution',
    已选套餐: 'The selected plan',
    线下支付总价: 'Total offline payment',
    线上支付总价: 'Total online payment',
    订阅费: 'Subscription fee per month',
    每月: 'Per month',
    立即线上支付: 'Online payment Now',
    提交成功: 'Success',
    取消: 'Cancel',
    确定使用: 'Sure',
    合计总价: 'Total price',
    返回dashboard: 'jump dashboard',
    配置说明: 'Configuration description'
  },
  openShopSettle: {
    账单结算: 'Bill settlement',
    应缴周期数: 'Number of payable cycles',
    期: 'period',
    线下商品支付: 'Offline Solution payment',
    绑定的支付渠道: 'Bound payment channels',
    已选模板: 'The selected template',
    已选商品: 'The selected Solution',
    线下支付总价: 'Total offline payment',
    线上支付总价: 'Total online payment',
    订阅费: 'Subscription fee',
    立即线上支付: 'Online payment Now',
    支付信息: 'Payment information',
    已支付: 'Paid',
    未支付: 'Unpaid'
  },
  bankingSolutions: {
    title: 'Banking Solutions',
    desc: 'Choose from one or more of our banking solutions and apply in one simple click.',
    multiCurrencyTitle: 'Multi-currency Account',
    multiCurrencyDesc: 'Open a multi-currency virtual bank account, with ease.',
    rewardsTitle: 'Exclusive Rewards',
    rewardsDesc: 'Get access to great perks only for IE Shop customers.',
    IntegrationTitle: 'Seamless Integration',
    IntegrationDesc: 'Your data is automatically transferred to the bank.',
    supportTitle: 'Dedicated support',
    supportDesc: 'Receive support along the way from our team.',
    mieCard: 'Mie Card',
    mieCardDesc: 'The first corporate card fro startups and modern businesses with top-up feature, no personal guarantees, no security deposits required, competitive rewards, and build on the UnionPay netework.',
    points: 'Earn reward points with qualifying activities',
    pointsDesc: 'Get 25,000 points after spending $3,000 using your Mie card'
  }
}
